/*
 * Copyright (c) 2026 Ambits Technologies LLC. All rights reserved.
 *
 * This source code is the proprietary and confidential property of
 * Ambits Technologies LLC. Unauthorized copying, modification, distribution,
 * or use of this software, via any medium, is strictly prohibited.
 *
 * MyAmbits - AI-Powered Location Safety & Social Platform
 * https://myambits.com
 */

import * as Sentry from "@sentry/react";
import { logCrash } from "@/utils/crashlytics";
import { triggerCrashlyticsTestCrash } from "@/utils/crashlyticsTest";

export default function SentryTest() {
  if (!import.meta.env.DEV) return null;

  return (
    <div className="fixed bottom-20 right-4 z-[9999] p-4 space-y-2 max-w-xs rounded-xl border border-white/20 bg-gray-900 text-white shadow-2xl">
      <p className="text-xs font-bold text-yellow-400 uppercase tracking-wide">
        Dev: Error Monitoring
      </p>
      <button
        onClick={() => {
          throw new Error("Sentry test error from SentryTest component");
        }}
        className="w-full px-3 py-2 rounded-lg bg-red-600 text-white text-xs font-medium hover:bg-red-500 transition-colors"
      >
        Throw Test Error
      </button>
      <button
        onClick={() => {
          Sentry.addBreadcrumb({
            category: "test",
            message: "Test breadcrumb from SentryTest",
            level: "info",
          });
          alert("Breadcrumb logged to Sentry");
        }}
        className="w-full px-3 py-2 rounded-lg bg-indigo-600 text-white text-xs font-medium hover:bg-indigo-500 transition-colors"
      >
        Log Test Breadcrumb
      </button>
      <button
        onClick={async () => {
          await logCrash("Test Crashlytics log from SentryTest");
          alert("Crashlytics log sent (native only)");
        }}
        className="w-full px-3 py-2 rounded-lg bg-emerald-600 text-white text-xs font-medium hover:bg-emerald-500 transition-colors"
      >
        Test Crashlytics Log
      </button>
      <button
        onClick={() => triggerCrashlyticsTestCrash()}
        className="w-full px-3 py-2 rounded-lg bg-red-700 text-white text-xs font-medium hover:bg-red-600 transition-colors"
      >
        [DEV iOS] Test Crashlytics Crash
      </button>
    </div>
  );
}
